function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.353 1.647a.5.5 0 00-.708 0l-6 6a.5.5 0 000 .708l6 6a.5.5 0 00.708-.708L5.706 8l5.647-5.646a.5.5 0 000-.708z"
});

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 16 16",
    fill: "#0063E3"
  }, props), _ref);
};

export default SvgArrow;